/**
 * @generated SignedSource<<ac098ad71b5fce18b0d6bcc81b347fde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResetUserPasswordInput = {
  clientMutationId?: string | null | undefined;
  key?: string | null | undefined;
  login?: string | null | undefined;
  password?: string | null | undefined;
};
export type Auth_ResetUserPassword_Mutation$variables = {
  input: ResetUserPasswordInput;
};
export type Auth_ResetUserPassword_Mutation$data = {
  readonly resetUserPassword: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly avatar: {
        readonly url: string | null | undefined;
      } | null | undefined;
      readonly capabilities: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly description: string | null | undefined;
      readonly email: string | null | undefined;
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly meta: {
        readonly jobRole: string | null | undefined;
        readonly profileArticleLinks: ReadonlyArray<{
          readonly iconName: string | null | undefined;
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly profileImage: {
          readonly id: string;
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
        } | null | undefined;
        readonly profileSocialLinks: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly nicename: string | null | undefined;
      readonly nickname: string | null | undefined;
      readonly role: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Auth_ResetUserPassword_Mutation = {
  response: Auth_ResetUserPassword_Mutation$data;
  variables: Auth_ResetUserPassword_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetUserPasswordPayload",
    "kind": "LinkedField",
    "name": "resetUserPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nicename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "size",
                "value": 10
              }
            ],
            "concreteType": "Avatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": "avatar(size:10)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User_Meta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MediaItem",
                "kind": "LinkedField",
                "name": "profileImage",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaItemUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaDetails",
                    "kind": "LinkedField",
                    "name": "mediaDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MediaSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceUrl",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileSocialLinks",
                "kind": "LinkedField",
                "name": "profileSocialLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User_Meta_profileArticleLinks",
                "kind": "LinkedField",
                "name": "profileArticleLinks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nickname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capabilities",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Auth_ResetUserPassword_Mutation",
    "selections": (v4/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Auth_ResetUserPassword_Mutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a4357b05c02ef526463df69599d67e81",
    "id": null,
    "metadata": {},
    "name": "Auth_ResetUserPassword_Mutation",
    "operationKind": "mutation",
    "text": "mutation Auth_ResetUserPassword_Mutation(\n  $input: ResetUserPasswordInput!\n) {\n  resetUserPassword(input: $input) {\n    clientMutationId\n    user {\n      id\n      slug\n      role\n      username\n      name\n      nicename\n      avatar(size: 10) {\n        url\n      }\n      meta {\n        jobRole\n        profileImage {\n          id\n          mediaItemUrl\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n        }\n        profileSocialLinks {\n          name\n          url\n        }\n        profileArticleLinks {\n          name\n          iconName\n          url\n        }\n      }\n      nickname\n      firstName\n      lastName\n      description\n      email\n      capabilities\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9d6f76f5c4677651db18f30c55c236d";

export default node;
